module.exports = __webpack_public_path__ + "static/img/combo-e.f12a4ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bigengineering/combo-e.jpg
// module id = BXku
// module chunks = 22